import { HOST } from '../config';
import { apiDelete, apiGet, apiPost } from '../api';
import { fetchGetOrderById } from './orders';
import { cancelSources } from '../config/cancelAxiosRequest';
import axios from 'axios';

export const A = {
  FETCH_SUPPLIES_REQUEST: 'FETCH_SUPPLIES_REQUEST',
  FETCH_SUPPLIES_SUCCESS: 'FETCH_SUPPLIES_SUCCESS',
  FETCH_SUPPLIES_FAILURE: 'FETCH_SUPPLIES_FAILURE',

  FETCH_CURRENT_SUPPLY_REQUEST: 'FETCH_CURRENT_SUPPLY_REQUEST',
  FETCH_CURRENT_SUPPLY_SUCCESS: 'FETCH_CURRENT_SUPPLY_SUCCESS',
  FETCH_CURRENT_SUPPLY_FAILURE: 'FETCH_CURRENT_SUPPLY_FAILURE',

  REQUEST_GET_SUPPLY_HISTORY: 'REQUEST_GET_SUPPLY_HISTORY',
  RECEIVE_GET_SUPPLY_HISTORY: 'RECEIVE_GET_SUPPLY_HISTORY',
  ERROR_GET_SUPPLY_HISTORY: 'ERROR_GET_SUPPLY_HISTORY',

  SET_CURRENT_SUPPLY_UNSAVED: 'SET_CURRENT_SUPPLY_UNSAVED',
  SET_CURRENT_SUPPLY: 'SET_CURRENT_SUPPLY',

  REQUEST_GET_SUPPLIES_REPORT: 'REQUEST_GET_SUPPLIES_REPORT',
  RECEIVE_GET_SUPPLIES_REPORT: 'RECEIVE_GET_SUPPLIES_REPORT',
  ERROR_GET_SUPPLIES_REPORT: 'ERROR_GET_SUPPLIES_REPORT',

  REQUEST_GET_SUPPLIES_EXPORT_TASKS: 'REQUEST_GET_SUPPLIES_EXPORT_TASKS',
  RECEIVE_GET_SUPPLIES_EXPORT_TASKS: 'RECEIVE_GET_SUPPLIES_EXPORT_TASKS',
  ERROR_GET_SUPPLIES_EXPORT_TASKS: 'ERROR_GET_SUPPLIES_EXPORT_TASKS',

  REQUEST_COPY_SUPPLY: 'REQUEST_COPY_SUPPLY',
  RECEIVE_COPY_SUPPLY: 'RECEIVE_COPY_SUPPLY',
  ERROR_COPY_SUPPLY: 'ERROR_COPY_SUPPLY',

  REQUEST_REFRESH_SUPPLY: 'REQUEST_REFRESH_SUPPLY',
  RECEIVE_REFRESH_SUPPLY: 'RECEIVE_REFRESH_SUPPLY',
  ERROR_REFRESH_SUPPLY: 'ERROR_REFRESH_SUPPLY',

  REQUEST_GET_ACCEPTANCE: 'REQUEST_GET_ACCEPTANCE',
  RECEIVE_GET_ACCEPTANCE: 'RECEIVE_GET_ACCEPTANCE',
  ERROR_GET_ACCEPTANCE: 'ERROR_GET_ACCEPTANCE',

  REQUEST_GET_SUPPLY_WORKSHEET: 'REQUEST_GET_SUPPLY_WORKSHEET',
  RECEIVE_GET_SUPPLY_WORKSHEET: 'RECEIVE_GET_SUPPLY_WORKSHEET',
  ERROR_GET_SUPPLY_WORKSHEET: 'ERROR_GET_SUPPLY_WORKSHEET',

  REQUEST_UPDATE_SUPPLY_WORKSHEET: 'REQUEST_UPDATE_SUPPLY_WORKSHEET',
  RECEIVE_UPDATE_SUPPLY_WORKSHEET: 'RECEIVE_UPDATE_SUPPLY_WORKSHEET',
  ERROR_UPDATE_SUPPLY_WORKSHEET: 'ERROR_UPDATE_SUPPLY_WORKSHEET',

  REQUEST_GET_SUPPLY_WORKSHEET_FORM_TEMPLATE: 'REQUEST_GET_SUPPLY_WORKSHEET_FORM_TEMPLATE',
  RECEIVE_GET_SUPPLY_WORKSHEET_FORM_TEMPLATE: 'RECEIVE_GET_SUPPLY_WORKSHEET_FORM_TEMPLATE',
  ERROR_GET_SUPPLY_WORKSHEET_FORM_TEMPLATE: 'ERROR_GET_SUPPLY_WORKSHEET_FORM_TEMPLATE',

  REQUEST_POST_ORDER_FBM_DOCS_NECESSARY: 'REQUEST_POST_ORDER_FBM_DOCS_NECESSARY',
  RECEIVE_POST_ORDER_FBM_DOCS_NECESSARY: 'RECEIVE_POST_ORDER_FBM_DOCS_NECESSARY',
  ERROR_POST_ORDER_FBM_DOCS_NECESSARY: 'ERROR_POST_ORDER_FBM_DOCS_NECESSARY',

  REQUEST_CANCEL_SUPPLY: 'REQUEST_CANCEL_SUPPLY',
  RECEIVE_CANCEL_SUPPLY: 'RECEIVE_CANCEL_SUPPLY',
  ERROR_CANCEL_SUPPLY: 'ERROR_CANCEL_SUPPLY',
};

const fetchSuppliesRequest = () => ({
  type: A.FETCH_SUPPLIES_REQUEST,
});

const fetchSuppliesSuccess = (response) => ({
  type: A.FETCH_SUPPLIES_SUCCESS,
  ...response,
});

const fetchSuppliesFailure = (err) => ({
  type: A.FETCH_SUPPLIES_SUCCESS,
  err,
});

const fetchCurrentSupplyRequest = () => ({
  type: A.FETCH_CURRENT_SUPPLY_REQUEST,
});

const fetchCurrentSupplySuccess = (supply) => ({
  type: A.FETCH_CURRENT_SUPPLY_SUCCESS,
  supply,
});

const fetchCurrentSupplyFailure = (err) => ({
  type: A.FETCH_CURRENT_SUPPLY_FAILURE,
  err,
});

const setCurrentSupply = (supply) => ({
  type: A.SET_CURRENT_SUPPLY,
  supply,
});

export const setCurrentSupplyUnsaved = (currentSupplyUnsaved) => ({
  type: A.SET_CURRENT_SUPPLY_UNSAVED,
  currentSupplyUnsaved,
});

export const fetchSupplies = (data) => (dispatch, getState) => {
  const {
    page,
    id,
    size,
    status,
    supplier_id,
    consignor_id,
    date_from,
    date_to,
    date_of_accept_from,
    date_of_accept_to,
    arrival_date_from,
    arrival_date_to,
  } = data;

  let url =
    `${HOST}/api/lite/purchase_orders?order=date+desc` +
    (id ? `&id=${id}` : '') +
    (page ? `&page=${page}` : '') +
    (status ? `&statuses=${status}` : '') +
    (supplier_id ? `&supplier_id=${supplier_id}` : '') +
    (consignor_id ? `&consignor_id=${consignor_id}` : '') +
    (date_from ? `&date_from=${date_from}` : '') +
    (date_to ? `&date_to=${date_to}` : '') +
    (date_of_accept_from ? `&date_of_accept_from=${date_of_accept_from}` : '') +
    (date_of_accept_to ? `&date_of_accept_to=${date_of_accept_to}` : '') +
    (arrival_date_from ? `&arrival_date_from=${arrival_date_from}` : '') +
    (arrival_date_to ? `&arrival_date_to=${arrival_date_to}` : '') +
    (size ? `&size=${size}` : '');

  dispatch(fetchSuppliesRequest());
  return new Promise((resolve, reject) => {
    if (cancelSources.getSupplies) {
      cancelSources.getSupplies('Cancel fetchSupplies request');
      cancelSources.getSupplies = null;
    }

    const source = axios.CancelToken.source();
    cancelSources.getSupplies = source.cancel;

    apiGet({
      url,
      tokens: getState().auth.tokenData,
      cancelToken: source.token,
      callback: (res) => {
        cancelSources.getSupplies = null;
        if (res.success) {
          if (res.purchaseOrders.length === 0) {
            res.purchaseOrders = ['NOT_FOUND'];
            dispatch(fetchSuppliesSuccess(res));
            resolve(res);
          }

          dispatch(fetchSuppliesSuccess(res));
          resolve(res);
        } else {
          const err = { data: { errors: res.errors } };
          dispatch(fetchSuppliesFailure(err));
          reject(err);
        }
      },
      error: (err) => {
        cancelSources.getSupplies = null;
        dispatch(fetchSuppliesFailure(err));
        reject(err);
      },
    });
  });
};

export const fetchSupplyById = (id) => (dispatch, getState) => {
  dispatch(fetchCurrentSupplyRequest());
  return new Promise((resolve, reject) => {
    dispatch(setCurrentSupplyUnsaved(false));

    if (id) {
      let url = `${HOST}/api/lite/purchase_orders?full_info=true&id=${id}`;
      apiGet({
        url,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          try {
            if (res.success) {
              if (res.purchaseOrders && res.purchaseOrders.length) {
                dispatch(fetchCurrentSupplySuccess(res.purchaseOrders[0]));
                resolve(res.purchaseOrders[0]);
              }
            }
          } catch (error) {
            const err = { data: { errors: res.errors } };
            dispatch(fetchCurrentSupplyFailure(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(fetchCurrentSupplyFailure(err));
          reject(err);
        },
      });
    } else {
      //При пустом ID это добавление новой записи, заполненной значениями по умолчанию
      const defaultWarehouse = getState().orders.warehouses.find(
        (warehouse) => warehouse.isDefault,
      );

      const newSupply = {
        id: '',
        status: 'NEW',
        totalOrderSum: 0.0,
        totalQuantity: 0,
        planItems: [],
        warehouseCode: defaultWarehouse && defaultWarehouse.code,
        warehouseName: defaultWarehouse && defaultWarehouse.title,
      };
      dispatch(fetchCurrentSupplySuccess(newSupply));
      resolve(newSupply);
    }
  });
};

export const updateSupply = (id) => (dispatch, getState) => {
  dispatch(fetchCurrentSupplyRequest());
  let url = `${HOST}/api/lite/purchase_orders`;

  const currentSupplyState = getState().supplies.currentSupply;
  const currentSupply = id ? { ...currentSupplyState, id } : currentSupplyState;

  return new Promise((resolve, reject) => {
    apiPost({
      url,
      body: currentSupply,
      tokens: getState().auth.tokenData,
      callback: (res) => {
        if (res.success) {
          //Это не заменяет необходимости перечитать поставку после сохранения. Но это позволяет следдующей операцией без лишнего чтения поставки сохранить фактическое количество в случае создания новой поставки.
          dispatch(
            fetchCurrentSupplySuccess({
              ...currentSupply,
              id: res.orderId,
            }),
          );
          resolve(res.orderId); //Это не баг при копипасте с заказа. API возвращает ID новой/измененной записи поставки именно в поле orderId
        } else {
          const err = { data: { errors: res.errors } };
          dispatch(fetchCurrentSupplyFailure(err));
          reject(err);
        }
      },
      error: (err) => {
        dispatch(fetchCurrentSupplyFailure(err));
        reject(err);
      },
    });
  });
};

export const updateSupplyFact = () => (dispatch, getState) => {
  dispatch(fetchCurrentSupplyRequest());
  let url = `${HOST}/api/lite/purchase_orders/items/fact`;

  const { id, items } = getState().supplies.currentSupply;
  const factItems = items
    ? items.map((item) => ({
        num: item.num,
        variantId: item.variantId,
        /*quantity: item.quantityRaw,*/
        quantityRaw: item.quantityRaw || 0,
        vatRate: item.vatRate,
        price: item.price,
      }))
    : null;

  return new Promise((resolve, reject) => {
    apiPost({
      url,
      body: {
        id,
        items: factItems,
      },
      tokens: getState().auth.tokenData,
      callback: (res) => {
        if (res.success) {
          dispatch(fetchSuppliesSuccess());
          resolve(res.id);
        } else {
          const err = { data: { errors: res.errors } };
          dispatch(fetchCurrentSupplyFailure(err));
          reject(err);
        }
      },
      error: (err) => {
        dispatch(fetchCurrentSupplyFailure(err));
        reject(err);
      },
    });
  });
};

export const editCurrentSupply = (data) => (dispatch, getState) => {
  dispatch(setCurrentSupply(data));
  dispatch(setCurrentSupplyUnsaved(true));
};

export const setCurrentSupplyConfirmStatus = (confirmStatus) => (dispatch, getState) => {
  dispatch(
    editCurrentSupply({
      ...getState().supplies.currentSupply,
      confirmStatus,
    }),
  );
};

export const confirmSupply = () => (dispatch, getState) => {
  dispatch(fetchCurrentSupplyRequest());
  let url = `${HOST}/api/lite/purchase_orders/confirm`;
  return new Promise((resolve, reject) => {
    const id = getState().supplies.currentSupply.id;
    apiPost({
      url,
      body: {
        id,
        confirmStatus: 'APPROVED',
      },
      tokens: getState().auth.tokenData,
      callback: (res) => {
        if (res.success) {
          dispatch(fetchSuppliesSuccess());
          resolve(id);
        } else {
          const err = { data: { errors: res.errors } };
          dispatch(fetchCurrentSupplyFailure(err));
          reject(err);
        }
      },
      error: (err) => {
        dispatch(fetchCurrentSupplyFailure(err));
        reject(err);
      },
    });
  }).then((id) => dispatch(fetchSupplyById(id)));
};

export const confirmSupplyDifference = () => (dispatch, getState) => {
  dispatch(fetchCurrentSupplyRequest());
  let url = `${HOST}/api/lite/purchase_orders/accept_diff`;
  return new Promise((resolve, reject) => {
    const id = getState().supplies.currentSupply.id;
    apiPost({
      url,
      body: {
        id,
        accept: true,
      },
      tokens: getState().auth.tokenData,
      callback: (res) => {
        if (res.success) {
          dispatch(fetchSuppliesSuccess());
          resolve(id);
        } else {
          const err = { data: { errors: res.errors } };
          dispatch(fetchCurrentSupplyFailure(err));
          reject(err);
        }
      },
      error: (err) => {
        dispatch(fetchCurrentSupplyFailure(err));
        reject(err);
      },
    });
  }).then((id) => dispatch(fetchSupplyById(id)));
};

export const completedSupply = () => (dispatch, getState) => {
  dispatch(fetchCurrentSupplyRequest());
  let url = `${HOST}/api/lite/purchase_orders/completed`;
  return new Promise((resolve, reject) => {
    const id = getState().supplies.currentSupply.id;
    apiPost({
      url,
      body: {
        id,
      },
      tokens: getState().auth.tokenData,
      callback: (res) => {
        if (res.success) {
          dispatch(fetchSuppliesSuccess());
          resolve(id);
        } else {
          const err = { data: { errors: res.errors } };
          dispatch(fetchCurrentSupplyFailure(err));
          reject(err);
        }
      },
      error: (err) => {
        dispatch(fetchCurrentSupplyFailure(err));
        reject(err);
      },
    });
  }).then((id) => dispatch(fetchSupplyById(id)));
};

export const returnToCompletionSupply = () => (dispatch, getState) => {
  dispatch(fetchCurrentSupplyRequest());
  let url = `${HOST}/api/lite/purchase_orders/set_in_process`;
  return new Promise((resolve, reject) => {
    const id = getState().supplies.currentSupply.id;
    apiPost({
      url,
      body: {
        id,
      },
      tokens: getState().auth.tokenData,
      callback: (res) => {
        if (res.success) {
          dispatch(fetchSuppliesSuccess());
          resolve(id);
        } else {
          const err = { data: { errors: res.errors } };
          dispatch(fetchCurrentSupplyFailure(err));
          reject(err);
        }
      },
      error: (err) => {
        dispatch(fetchCurrentSupplyFailure(err));
        reject(err);
      },
    });
  }).then((id) => dispatch(fetchSupplyById(id)));
};

export const fetchGetSupplyHistory = (supplyId) => {
  let url = `${HOST}/api/lite/purchase_orders/history?id=${supplyId}`;
  return (dispatch, getState) => {
    dispatch(requestGetSupplyHistory());
    return new Promise((resolve, reject) => {
      apiGet({
        url,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveGetSupplyHistory(res.events));
            resolve(res.events);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorGetSupplyHistory(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorGetSupplyHistory(err));
          reject(err);
        },
      });
    });
  };
};

const requestGetSupplyHistory = () => {
  return {
    type: A.REQUEST_GET_SUPPLY_HISTORY,
  };
};

const receiveGetSupplyHistory = (data) => {
  return {
    type: A.RECEIVE_GET_SUPPLY_HISTORY,
    data,
  };
};

const errorGetSupplyHistory = (err) => {
  return {
    type: A.ERROR_GET_SUPPLY_HISTORY,
    err,
  };
};

export const fetchGetPurchaseOrder = (supplyId) => {
  let url = `${HOST}/api/lite/export/purchase_order?id=${supplyId}`;
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      apiGet({
        url,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            reject(err);
          }
        },
        error: (err) => {
          reject(err);
        },
      });
    });
  };
};

export const fetchUploadSupplyFile = (data) => {
  const formData = new FormData();
  Object.keys(data).forEach((key) => {
    formData.append(key, data[key]);
  });
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      apiPost({
        url: `${HOST}/api/lite/purchase_orders/file`,
        tokens: getState().auth.tokenData,
        formData,
        callback: (res) => {
          if (res.success) {
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            reject(err);
          }
        },
        error: (err) => {
          reject(err);
        },
      });
    });
  };
};

export const fetchDeleteSupplyFile = (fileId) => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      apiDelete({
        url: `${HOST}/api/lite/purchase_orders/file?id=${fileId}`,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            reject(err);
          }
        },
        error: (err) => {
          reject(err);
        },
      });
    });
  };
};

export const fetchEditSupplyFile = (data) => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      apiPost({
        url: `${HOST}/api/lite/purchase_orders/file/edit`,
        tokens: getState().auth.tokenData,
        body: data,
        callback: (res) => {
          if (res.success) {
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            reject(err);
          }
        },
        error: (err) => {
          reject(err);
        },
      });
    });
  };
};

export const fetchGetSuppliesCount = (data) => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      apiPost({
        url: `${HOST}/api/lite/export/supply/count`,
        tokens: getState().auth.tokenData,
        body: data,
        callback: (res) => {
          if (res.success) {
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            reject(err);
          }
        },
        error: (err) => {
          reject(err);
        },
      });
    });
  };
};

export const fetchGetSuppliesReportById = (reportId) => {
  let url = `${HOST}/api/lite/export/supply?id=${reportId}`;
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      apiGet({
        url,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            reject(err);
          }
        },
        error: (err) => {
          reject(err);
        },
      });
    });
  };
};

export const fetchGetSuppliesReport = (data) => {
  let url = `${HOST}/api/lite/export/supply`;
  return (dispatch, getState) => {
    dispatch(requestGetSuppliesReport());
    return new Promise((resolve, reject) => {
      apiPost({
        url,
        tokens: getState().auth.tokenData,
        body: data,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveGetSuppliesReport());
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorGetSuppliesReport(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorGetSuppliesReport(err));
          reject(err);
        },
      });
    });
  };
};

const requestGetSuppliesReport = () => {
  return {
    type: A.REQUEST_GET_SUPPLIES_REPORT,
  };
};

const receiveGetSuppliesReport = (data) => {
  return {
    type: A.RECEIVE_GET_SUPPLIES_REPORT,
    data,
  };
};

const errorGetSuppliesReport = (err) => {
  return {
    type: A.ERROR_GET_SUPPLIES_REPORT,
    err,
  };
};

export const fetchGetSuppliesExportTasks = () => {
  let url = `${HOST}/api/lite/export/supply`;
  return (dispatch, getState) => {
    dispatch(requestGetSuppliesExportTasks());
    return new Promise((resolve, reject) => {
      apiGet({
        url,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(
              receiveGetSuppliesExportTasks({
                tasks: res.exportResults,
                recordsTotal: res.recordsTotal,
              }),
            );
            resolve({ tasks: res.exportResults, recordsTotal: res.recordsTotal });
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorGetSuppliesExportTasks(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorGetSuppliesExportTasks(err));
          reject(err);
        },
      });
    });
  };
};

const requestGetSuppliesExportTasks = () => {
  return {
    type: A.REQUEST_GET_SUPPLIES_EXPORT_TASKS,
  };
};

const receiveGetSuppliesExportTasks = (data) => {
  return {
    type: A.RECEIVE_GET_SUPPLIES_EXPORT_TASKS,
    data,
  };
};

const errorGetSuppliesExportTasks = (err) => {
  return {
    type: A.ERROR_GET_SUPPLIES_EXPORT_TASKS,
    err,
  };
};

export const fetchCopySupply = (supplyId) => {
  let url = `${HOST}/api/lite/purchase_orders/copy`;
  return (dispatch, getState) => {
    dispatch(requestCopySupply());
    return new Promise((resolve, reject) => {
      apiPost({
        url,
        tokens: getState().auth.tokenData,
        body: { id: supplyId },
        callback: (res) => {
          if (res.success) {
            dispatch(receiveCopySupply());
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorCopySupply(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorCopySupply(err));
          reject(err);
        },
      });
    });
  };
};

const requestCopySupply = () => {
  return {
    type: A.REQUEST_COPY_SUPPLY,
  };
};

const receiveCopySupply = (data) => {
  return {
    type: A.RECEIVE_COPY_SUPPLY,
    data,
  };
};

const errorCopySupply = (err) => {
  return {
    type: A.ERROR_COPY_SUPPLY,
    err,
  };
};

export const fetchRefreshSupply = (supplyId) => {
  let url = `${HOST}/api/lite/admin/purchase_order/refresh_from_wms`;
  return (dispatch, getState) => {
    dispatch(requestRefreshSupply());
    return new Promise((resolve, reject) => {
      apiPost({
        url,
        tokens: getState().auth.tokenData,
        body: { id: supplyId },
        callback: (res) => {
          if (res.success) {
            dispatch(receiveRefreshSupply());
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorRefreshSupply(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorRefreshSupply(err));
          reject(err);
        },
      });
    });
  };
};

const requestRefreshSupply = () => {
  return {
    type: A.REQUEST_REFRESH_SUPPLY,
  };
};

const receiveRefreshSupply = (data) => {
  return {
    type: A.RECEIVE_REFRESH_SUPPLY,
    data,
  };
};

const errorRefreshSupply = (err) => {
  return {
    type: A.ERROR_REFRESH_SUPPLY,
    err,
  };
};

export const fetchGetAcceptance = (supplyId) => {
  let url = `${HOST}/api/lite/purchase_orders/worksheet/form_template?order_id=${supplyId}`;
  return (dispatch, getState) => {
    dispatch(requestGetAcceptance());
    return new Promise((resolve, reject) => {
      apiGet({
        url,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveGetAcceptance(res.events));
            resolve(res.events);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorGetAcceptance(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorGetAcceptance(err));
          reject(err);
        },
      });
    });
  };
};

const requestGetAcceptance = () => {
  return {
    type: A.REQUEST_GET_ACCEPTANCE,
  };
};

const receiveGetAcceptance = (data) => {
  return {
    type: A.RECEIVE_GET_ACCEPTANCE,
    data,
  };
};

const errorGetAcceptance = (err) => {
  return {
    type: A.ERROR_GET_ACCEPTANCE,
    err,
  };
};

export const fetchGetSupplyWorksheet = (orderId) => {
  let url = `${HOST}/api/lite/purchase_orders/worksheet?order_id=${orderId}`;
  return (dispatch, getState) => {
    dispatch(requestGetSupplyWorksheet());
    return new Promise((resolve, reject) => {
      apiGet({
        url,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveGetSupplyWorksheet());
            resolve(res.form_content);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorGetSupplyWorksheet(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorGetSupplyWorksheet(err));
          reject(err);
        },
      });
    });
  };
};

const requestGetSupplyWorksheet = () => {
  return {
    type: A.REQUEST_GET_SUPPLY_WORKSHEET,
  };
};

const receiveGetSupplyWorksheet = (data) => {
  return {
    type: A.RECEIVE_GET_SUPPLY_WORKSHEET,
    data,
  };
};

const errorGetSupplyWorksheet = (err) => {
  return {
    type: A.ERROR_GET_SUPPLY_WORKSHEET,
    err,
  };
};

export const fetchUpdateSupplyWorksheet = (data) => {
  let url = `${HOST}/api/lite/purchase_orders/worksheet`;
  return (dispatch, getState) => {
    dispatch(requestUpdateSupplyWorksheet());
    return new Promise((resolve, reject) => {
      apiPost({
        url,
        tokens: getState().auth.tokenData,
        body: data,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveUpdateSupplyWorksheet());
            resolve(data);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorUpdateSupplyWorksheet(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorUpdateSupplyWorksheet(err));
          reject(err);
        },
      });
    });
  };
};

const requestUpdateSupplyWorksheet = () => {
  return {
    type: A.REQUEST_UPDATE_SUPPLY_WORKSHEET,
  };
};

const receiveUpdateSupplyWorksheet = (data) => {
  return {
    type: A.RECEIVE_UPDATE_SUPPLY_WORKSHEET,
    data,
  };
};

const errorUpdateSupplyWorksheet = (err) => {
  return {
    type: A.ERROR_UPDATE_SUPPLY_WORKSHEET,
    err,
  };
};

export const fetchGetSupplyWorksheetFormTemplate = (orderId) => {
  let url = `${HOST}/api/lite/purchase_orders/worksheet/form_template?order_id=${orderId}`;
  return (dispatch, getState) => {
    dispatch(requestGetSupplyWorksheetFormTemplate());
    return new Promise((resolve, reject) => {
      apiGet({
        url,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveGetSupplyWorksheetFormTemplate(res));
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(receiveGetSupplyWorksheetFormTemplate(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorGetSupplyWorksheetFormTemplate(err));
          reject(err);
        },
      });
    });
  };
};

const requestGetSupplyWorksheetFormTemplate = () => {
  return {
    type: A.REQUEST_GET_SUPPLY_WORKSHEET_FORM_TEMPLATE,
  };
};

const receiveGetSupplyWorksheetFormTemplate = (data) => {
  return {
    type: A.RECEIVE_GET_SUPPLY_WORKSHEET_FORM_TEMPLATE,
    data,
  };
};

const errorGetSupplyWorksheetFormTemplate = (err) => {
  return {
    type: A.ERROR_GET_SUPPLY_WORKSHEET_FORM_TEMPLATE,
    err,
  };
};

export const fetchChangeOrderFbmDocsNecessary = (data) => {
  let url = `${HOST}/api/lite/orders/fbm/docs/necessary`;
  return (dispatch, getState) => {
    dispatch(requestOrderFbmDocsNecessary());
    return new Promise((resolve, reject) => {
      apiPost({
        url,
        body: data,
        tokens: getState().auth.tokenData,
        callback: async (res) => {
          if (res.success) {
            dispatch(receiveOrderFbmDocsNecessary());
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorOrderFbmDocsNecessary(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorOrderFbmDocsNecessary(err));
          reject(err);
        },
      });
    });
  };
};

const requestOrderFbmDocsNecessary = () => {
  return {
    type: A.REQUEST_POST_ORDER_FBM_DOCS_NECESSARY,
  };
};

const receiveOrderFbmDocsNecessary = () => {
  return {
    type: A.RECEIVE_POST_ORDER_FBM_DOCS_NECESSARY,
  };
};

const errorOrderFbmDocsNecessary = (err) => {
  return {
    type: A.ERROR_POST_ORDER_FBM_DOCS_NECESSARY,
    err,
  };
};

export const fetchCancelSupply = (supplyId) => {
  let url = `${HOST}/api/lite/admin/purchase_order/cancelled`;
  return (dispatch, getState) => {
    dispatch(requestCancelSupply());
    return new Promise((resolve, reject) => {
      apiPost({
        url,
        tokens: getState().auth.tokenData,
        body: { id: supplyId },
        callback: (res) => {
          if (res.success) {
            dispatch(receiveCancelSupply());
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorCancelSupply(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorCancelSupply(err));
          reject(err);
        },
      });
    });
  };
};

const requestCancelSupply = () => {
  return {
    type: A.REQUEST_CANCEL_SUPPLY,
  };
};

const receiveCancelSupply = (data) => {
  return {
    type: A.RECEIVE_CANCEL_SUPPLY,
    data,
  };
};

const errorCancelSupply = (err) => {
  return {
    type: A.ERROR_CANCEL_SUPPLY,
    err,
  };
};
